import React from 'react'
import { GrFormClose } from 'react-icons/gr'
import { IValueType, SchemaManager } from '../schemamanager/schemaManager'
import { useDragDrop } from './useDragDrop'

export interface IChipsProps {
  chipsArray: string[]
  onDeleteChip: (chip: string) => void
  onDrop: (chips: string[]) => void
  disabled: boolean
}

export const Chips = ({chipsArray, onDeleteChip, onDrop, disabled}: IChipsProps) => {

  const dnd = useDragDrop()
  dnd.InitData(chipsArray)

  const dndProps = (ind: number) => ({
      draggable: !disabled,
      onDragStart: dnd.onDragStart(ind),
      onDragOver: dnd.onDragOver,
      onDragEnter: dnd.onDragEnter(ind),
      onDrop: dnd.onDrop,
      onDragEnd: dnd.onDragEnd(dropped)
  })
    

  const dropped = (dropdata: any) => {
    if (dropdata) {
      onDrop(dropdata)
    }
  }

  const handleDeleteChip = (chip: string) => {
    if (!disabled) {
      onDeleteChip(chip)
    }
  }

  const Chip = (props: any) => {
    return (
      <div className='flex border bg-gray-300 rounded-sm items-center p-1 m-1 hover:bg-gray-200' {...dndProps(props.ind)} >
        <span className='text-xs mr-1'>{props.value}</span>
        <GrFormClose
          className='cursor-pointer hover:bg-gray-100 rounded-full'
          onClick={() => handleDeleteChip(props.value)}
        />
      </div>
    )
  }

  const typ = SchemaManager.checkValueType(chipsArray)
  if (typ !== IValueType.array || !chipsArray || chipsArray.length === 0) return null
  const style: React.CSSProperties = {display: 'flex', flexWrap: 'wrap', gridColumn: 1 }
  
  return (
    <div style={style} >
      {chipsArray.map((i, ind) => (
        <Chip key={i} value={i} ind={ind}/>
      ))}
    </div>
  )
}
